export default {
  cards: {
    slidesPerView: 1.05,
    spaceBetween: 16,
    breakpoints: {
      375: {
        slidesPerView: 'auto',
        spaceBetween: 16,
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 16,
      },
      1280: {
        slidesPerView: 3,
        spaceBetween: 32,
      },
    },
  },
  'cards-4': {
    slidesPerView: 1.05,
    spaceBetween: 16,
    breakpoints: {
      375: {
        slidesPerView: 'auto',
        spaceBetween: 16,
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 16,
      },
      1280: {
        slidesPerView: 4,
        spaceBetween: 32,
      },
    },
  },
  'card-images': {
    slidesPerView: 1,
    loop: true,
  },
  'news-single': {
    slidesPerView: 1,
    loop: true,
    autoHeight: true,
  },
  thumbs: {
    spaceBetween: 16,
    slidesPerView: 'auto',
    watchSlidesProgress: true,
  },
  hero: {
    autoplay: {
      delay: 4500,
      waitForTransition: false,
    },
    virtualTranslate: true,
    slidesPerView: 1,
  },
  property: {
    autoHeight: true,
    spaceBetween: 16,
  },
}
